import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyVehicleCorrectiveImagesFormTabsParamsType,
  GetBodyVehicleCorrectiveImagesFormTabsResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImagesFormTabs/getBodyVehicleCorrectiveImagesFormTabs.type';

export const getBodyVehicleCorrectiveImagesFormTabsTabsFunction = (
  params: GetBodyVehicleCorrectiveImagesFormTabsParamsType,
): Promise<GetBodyVehicleCorrectiveImagesFormTabsResponseType> =>
  fetchApi.get(`/body/reports/${params.id}/images/corrective/form/entry_tabs/`);
